import useSplitedTableByColumn from '../../../hooks/useSplitedTableByColumn';
import { Table } from '../../Table';
import { StyledTables } from './style';
import { TableComponentProps } from '../types';

const _tables = [
  {
    name: 'Vega Exposure',
    key: 'vega',
    order: 143,
    columnLables: {
      current_market_risk_measure_value: {
        name: 'Risk measure value for Vega exposure at current market levels *',
        order: 143
      },
      lower_market_risk_measure_value: {
        name: 'Risk measure value for Vega exposure at market levels 10% lower *',
        order: 144
      },
      higher_market_risk_measure_value: {
        name: 'Risk measure value for Vega exposure at market levels 10%  higher *',
        order: 145
      },
      risk_measure_description: {
        name: 'Risk measure description',
        order: 147
      }
    }
  }
];

export function Vega({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useSplitedTableByColumn({
    data: funds[currentDataKey]?.fund_data?.VEGA_RISK_MEASURE,
    onChangeFund,
    schema: schema.VEGA_RISK_MEASURE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.VEGA_RISK_MEASURE?.field_names || [],
    tableName: 'VEGA_RISK_MEASURE',
    isMultiFunds,
    funds,
    tables: _tables,
    isSingleData: true
  });

  return (
    <StyledTables id="reporttables-vega-group">
      {tables.map((rows, index) => (
        <Table
          key={index + 'VEGA_RISK_MEASURE'}
          id={`reporttables-vega-table-${index + 1}`}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
        />
      ))}
    </StyledTables>
  );
}
